import { render, staticRenderFns } from "./CourseDashboard.vue?vue&type=template&id=49e06cef&scoped=true&"
import script from "./CourseDashboard.vue?vue&type=script&lang=js&"
export * from "./CourseDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e06cef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49e06cef', component.options)
    } else {
      api.reload('49e06cef', component.options)
    }
    module.hot.accept("./CourseDashboard.vue?vue&type=template&id=49e06cef&scoped=true&", function () {
      api.rerender('49e06cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseDashboard.vue"
export default component.exports